export enum ShipmentLocation {
  AMAZON = 'AMAZON',
  WAREHOUSE = 'WAREHOUSE'
}
